export const environment = {
  production: true,
  apiBaseUrl: 'https://sylinterpreterapi.azurewebsites.net/',
  identityServerBaseUrl: 'https://sylidentity.azurewebsites.net'
};
